module.exports = __webpack_public_path__ + "media/img/decorations/info-img-bg-desk-8ea6ae890113c6d2849aa6b5d7207ab1.svg";